module.exports = __webpack_public_path__ + "img/spinner-branded.66337a35.svg";